import { ApiRequestConfig } from 'api';
import { runSaga } from 'redux-saga';
import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';
import { RootState } from 'typesafe-actions';
import { post } from 'features/api';

export async function postAsync<
  Response = unknown,
  Data extends Record<string, unknown> = Record<string, unknown>,
>(
  store: MiddlewareAPI<Dispatch<AnyAction>, RootState>,
  path: string,
  data: Data,
  config?: ApiRequestConfig,
): Promise<Response> {
  return (await runSaga(
    {
      dispatch: (action: AnyAction) => store.dispatch(action),
      getState: () => store.getState(),
    },
    function* executePostRequest() {
      return yield* post(path, data, config);
    },
  ).toPromise()) as Promise<Response>;
}
